const initialState = {
  loading: false,

  planContext: {},
  studentPlans: {},
  districtIlps: [],

  allStudentsSelected: false,
  selectedStudents: [],
  /**
   * Used when allStudensSelected it's set to true and students are removed in order to send to the API
   * Student Hash + deselectedStudents Array
   */
  deselectedStudents: [],

  guardiansCount: 0,
  isBusyRetrievingGuardiansCount: false,

  planFilters: {
    search: null,
    sortField: 'last_name',
    sortOrder: '',
    page: 1,
    pageSize: 10,
    planStatus: [],
  },
  statusFilter: {},
  guardianList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'PERSONALIZED_PLANS/SET_BUSY':
      return {
        ...state,
        loading: action.mode,
      };
    case 'PERSONALIZED_PLANS/POPULATE_PLAN_LIST_CONTEXT':
      return {
        ...state,
        planContext: action.planContext,
      };
    case 'PERSONALIZED_PLANS/STUDENT_YEARS':
      return {
        ...state,
        districtIlps: action.districtIlps,
        studentDeadline: action.studentDeadline,
        planStartDate: action.planStartDate,
      };
    case 'PERSONALIZED_PLANS/STATUS_FILTER':
      return {
        ...state,
        statusFilter: action.statusFilter,
      };
    case 'PERSONALIZED_PLANS/POPULATE_STUDENTS':
      return {
        ...state,
        studentPlans: action.studentPlans,
      };
    case 'PERSONALIZED_PLANS/SET_GRID_PAGE':
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          page: action.page,
        },
      };
    case 'PERSONALIZED_PLANS/SET_ROWS_PER_PAGE':
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          pageSize: action.pageSize,
        },
      };
    case 'PERSONALIZED_PLANS/SET_PLAN_FILTER':
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          ...action.filter,
        },
      };
    case 'PERSONALIZED_PLANS/SET_SORTING_COLUMN': {
      const currentOrderingDirection = state.planFilters.sortOrder;
      const reverseOrder = currentOrderingDirection === '' ? '-' : '';
      const shouldReverseDirection =
        state.planFilters.sortField === action.sortField;
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          sortField: action.sortField,
          sortOrder: shouldReverseDirection
            ? reverseOrder
            : currentOrderingDirection,
        },
      };
    }
    case 'PERSONALIZED_PLANS/REMOVE_ACTIVE_FILTER': {
      const removeFromList = Array.isArray(
        state.planFilters[action.filterName],
      );
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          [action.filterName]: removeFromList
            ? state.planFilters[action.filterName].filter(
                ({ value }) => value === action.filterValue,
              )
            : undefined,
        },
      };
    }
    case 'PERSONALIZED_PLANS/TOGGLE_ALL_STUDENTS_SELECTION':
      return {
        ...state,
        allStudentsSelected: [true, false].includes(action.status)
          ? action.status
          : !state.allStudentsSelected,
        selectedStudents: [],
        deselectedStudents: [],
      };
    case 'PERSONALIZED_PLANS/TOGGLE_SINGLE_STUDENT_SELECTION': {
      if (action.allStudentsSelected) {
        const newSelection = state.deselectedStudents.includes(action.studentId)
          ? state.deselectedStudents.filter(id => id !== action.studentId)
          : [...state.deselectedStudents, action.studentId];
        return {
          ...state,
          deselectedStudents: newSelection,
        };
      }
      const newSelection = state.selectedStudents.includes(action.studentId)
        ? state.selectedStudents.filter(id => id !== action.studentId)
        : [...state.selectedStudents, action.studentId];
      return {
        ...state,
        selectedStudents: newSelection,
      };
    }
    case 'PERSONALIZED_PLANS/COURSE_LISTING_BUSY_RETRIEVING_GUARDIANS_COUNT':
      return {
        ...state,
        isBusyRetrievingGuardiansCount: action.mode,
      };
    case 'PERSONALIZED_PLANS/COURSE_LISTING_MANAGER_GUARDIANS_COUNT':
      return {
        ...state,
        guardiansCount: action.guardiansCount,
      };
    case 'PERSONALIZED_PLANS/POPULATE_GUARDIAN_LIST':
      return {
        ...state,
        guardianList: action.guardianList,
      };
    case 'PERSONALIZED_PLANS/POPULATE_STUDENTS_HASH':
      return {
        ...state,
        studentPlans: {
          ...state.studentPlans,
          studentsHash: action.studentPlans.studentsHash,
          guardianCount: action.studentPlans.guardianCount,
        },
      };
    default:
      return state;
  }
};
